import {
    GET_RAO_BY_ID_ERROR,
    GET_RAO_BY_ID_START,
    GET_RAO_BY_ID_SUCCESS,
    GET_RAO_BY_ID_RESET
} from "../actions/getRaoById";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function getRaoById(state = defaultState, { type, payload, error }) {
    switch (type) {
        case GET_RAO_BY_ID_START:
            return {
                ...defaultState,
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case GET_RAO_BY_ID_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                payload
            };
        case GET_RAO_BY_ID_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case GET_RAO_BY_ID_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
